// extracted by mini-css-extract-plugin
module.exports = {"timeFrames":"Timeframes_timeFrames__QmdBG","item":"Timeframes_item__vtkV9","selected":"Timeframes_selected__mEkkf"};